import React from "react";
import Button from "@amzn/meridian/button";
import Text from "@amzn/meridian/text";
import Modal, { ModalFooter } from "@amzn/meridian/modal";
import Row from "@amzn/meridian/row";

interface IDeleteModalProps {
    modalTitle: string;
    modalDescription: string;
    confirmHandler: (...params) => void;
    isModalOpen: boolean;
    setIsModalOpen: (value: any) => void;
}

export const DeleteModal: React.FC<IDeleteModalProps> = ({
    confirmHandler,
    isModalOpen,
    modalDescription,
    modalTitle,
    setIsModalOpen,
}) => {
    return (
        <React.Fragment>
            <Modal
                title={modalTitle}
                open={isModalOpen}
                scrollContainer="viewport"
                aria-describedby="modal-description"
                bodySpacingInset="200 600"
            >
                <Row alignmentHorizontal={"start"}>
                    <Text alignment={"start"}>{modalDescription}</Text>
                </Row>
                <ModalFooter>
                    <Row alignmentHorizontal="end" widths="fit">
                        <Button
                            type="secondary"
                            size="small"
                            onClick={() => {
                                setIsModalOpen(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                                setIsModalOpen(false);
                                confirmHandler();
                            }}
                        >
                            Yes, delete
                        </Button>
                    </Row>
                </ModalFooter>{" "}
            </Modal>
        </React.Fragment>
    );
};
